import { useTranslation } from 'react-i18next'
import '../translations/i18n'

const Translate = ({ name, val }) => {
  const { t } = useTranslation()
  return <>{t(name, val)}</>
}

export default Translate
